import { SystemFuncArgs } from '@brochington/ecstatic';
import CarnivoreCtx from 'editor/components/CarnivoreCtx';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import { Components } from '../components';
import Overlay from '../components/Overlay';

export const configureOverlayComponents = [
  Overlay,
  CarnivoreDoc,
  CarnivoreSheet,
  CarnivoreCtx,
];

export function configureOverlay(args: SystemFuncArgs<Components>): void {
  const { entity, components } = args;
  const overlayComp = components.get(Overlay);
  const { ctx: carnCtx } = components.get(CarnivoreCtx);
  const { doc } = components.get(CarnivoreDoc);
  const { sheet } = components.get(CarnivoreSheet);

  // init the overlay.
  if (
    !overlayComp.overlay &&
    (carnCtx as unknown as { ptr: number }).ptr !== 0 // Check to make sure that carn ctx is still bound.
  ) {
    const markupOverlay = carnCtx.createOverlay({
      id: overlayComp.id,
      index: overlayComp.index,
    });

    doc.addOverlay(markupOverlay.id);

    overlayComp.overlay = markupOverlay;
  }

  // Set the overlay canvas transform for all following draw commands.
  const { overlayCanvas, ctx } = overlayComp;

  const t: number[] = doc.transform;

  const sheetScaledHeight = sheet.height * t[5];

  ctx.resetTransform();

  ctx.clearRect(0, 0, overlayCanvas.width, overlayCanvas.height);

  // flip orientation to be bottom-left.
  ctx.transform(1, 0, 0, -1, 0, overlayCanvas.height);

  // transform canvas to match sheet transform.
  ctx.transform(
    t[0], // Horizontal scaling. A value of 1 results in no scaling.
    0, // Vertical skewing.
    0, // Horizontal skewing.
    t[5], // Vertical scaling. A value of 1 results in no scaling.
    t[12], // Horizontal translation (moving).
    overlayCanvas.height - t[13] - sheetScaledHeight // Vertical translation (moving).
  );

  // if (entity.state === 'destroying') {
  //   console.log('destroying overlay!');
  //   doc.re
  // }
}
